<div class="container">
  <div class="heading mat-typography">
    <span class="header-text"> Relay server name assignment </span>
    <div class="close">
      <mat-icon (click)="closeModal()">close</mat-icon>
    </div>
  </div>
  <div class="content">
    <div>
      <form class="form" [formGroup]="groupForm">
        <mat-form-field>
          <mat-label>Create new group</mat-label>
          <input matInput placeholder="Group name" [value]="this.groupForm.controls['groupName'].value" formControlName="groupName" name="groupName" />
        </mat-form-field>
        <div class="splitter mat-typography"> OR </div>
        <mat-form-field>
          <mat-label>Select existing group</mat-label>
          <mat-select [disabled]="dataToShow.length == 0" formControlName="groupName">
            @for (group of data.groupNames; track group) {
            <mat-option [value]="group">{{ group }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </div>
    @if (dataToShow.length >0) {
    <div class="servers">
      <app-card-table
        [data]="dataToShow"
        [tableHeaders]="headers"
        [options]="options"
        [enableInfiteScroll]="false"
        [enableTablePagination]="true"
        [enableRefresher]="false"
        [totalItems]="data.length"
        [currentPage]="0"
        (rowSelectedEvent)="selectionMade($event)"
        [breakpoint]="ScreenSize.TABLET"
      >
        ></app-card-table
      >
    </div>
    } @if (dataToShow.length == 0) {
    <div class="mat-typography no-servers"> There are currently no servers to group </div>
    } @if (showValidation) {
    <div class="mat-typography validation"> Warning: Some of the selected servers currently belong to another group and will be reassigned to the new group name. </div>
    }

    <div class="button-section">
      <button mat-raised-button class="button-left" (click)="addToGroup()"><mat-icon>add</mat-icon> Add to group</button>
      <button mat-raised-button class="button-right" (click)="addToGroup()"><mat-icon>close</mat-icon> Cancel</button>
    </div>
  </div>
</div>
